export default __webpack_public_path__ + "static/media/UFFICIO_ICONA.4919e5c7.svg";